import React from 'react';

export const Policy: React.FC = () => {
  return (
    <div className="font-sans bg-whiteYellow min-h-screen py-16 px-6 sm:py-12 sm:px-4">
      <div className="max-w-screen-lg mx-auto text-center sm:text-left">
        <h1 className="text-4xl max-md:text-2xl md:mt-24 max-md:mt-6 font-bold sm:text-3xl flex justify-center">
          プライバシーポリシー
        </h1>
        <div className="mt-24  max-md:mt-6">
          <p className="text-base leading-relaxed mt-6 text-start sm:text-left sm:max-w-[621px] mx-auto">
            The Apartment Hotel by
            Stylioの運営に関わる東急ライフィア株式会社および株式会社Unitoは、事業主である東急株式会社の個人情報保護方針に準拠し、お客様の個人情報の重要性を認識し大切に扱うとともに、よりよい商品・サービスを提供させていただくため、責任を持ってお客様の個人情報を保護いたします。
          </p>
          <p className="text-base leading-relaxed mt-6 text-start sm:text-left sm:max-w-[621px] mx-auto">
            詳しくは{' '}
            <a
              href="https://www.tokyu.co.jp/company/csr/society/transmission/privacy_policy1.html"
              className="underline text-blue-600"
              target="_blank"
              rel="noopener noreferrer"
            >
              こちら
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
